import { NavigationState } from "../../types";

export const resetClientEventHistory = (state: NavigationState) => {
  state.clientEvents = {
    fuel: {},
    road: {},
    service: {},
  };
};
